import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getBriefByKey } from "../../components/briefs/briefCreationManager";
import BriefTree from './briefTree';
import BriefInfoPanel from './BriefInfoPanel';

export default function View() {
    const { key } = useParams();
    const [briefMeta, setBriefMeta] = useState(null);
    const [treeItems, setTreeItems] = useState([]);

    useEffect(() => {
        getBriefByKey(key, setTreeItems, setBriefMeta);
    }, []);

    return (
        <div className="view-main-wrapper">
            <div className='view-main' style={{maxWidth: '960px', margin: '0 auto', padding: '0 2rem'}}>
                {briefMeta && <BriefInfoPanel meta={briefMeta} />}
                <BriefTree items={treeItems} setItems={setTreeItems}/>
            </div>
        </div>
    );
}
